export default "__VITE_ASSET__BFlw8HJM__"